import React, { Component } from 'react';
import { connect } from 'react-redux';
import { signUp, checkEmail } from '../../actions/sessions';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import MemberService from '../../services/memberService';
import CONSTANTS from '../../constants'

class SignUp extends Component {

    constructor(props) {
        MemberService.logout();
        super(props);
        const bname = props.match.params.bname;
        this.state = {
            bname: bname,
            email: null,
            first_name: null,
            last_name: null,
            primary_phone: null,
            address: null,
            city: null,
            state: null,
            zip: null,
            password: null,
            password_confirmation: null,
            isSubmitting: false
        };
    }


    renderField(field) {
        let hasError = field.meta.touched && field.meta.error;
        return (
            <div className="form-group">
                <div className="input-group">
                    <span className="input-group-addon is-invalid"><i className={field.icon}></i></span>
                    <input {...field.input} className={`form-control ${hasError ? 'is-invalid' : ''}`} type={field.type}
                           placeholder={field.placeholder} />
                </div>
                <div className="invalid-feedback">
                    { hasError ? field.meta.error : ''}
                </div>
            </div>
        )
    }

    onSubmit(values) {
        if(!this.state.email) {
            this.props.checkEmail(this.state.bname, values.email).then((response) => {
                if (response && MemberService.isEmailAvailableForSignUp(response)) {
                    this.setState({email: values.email, bname: this.state.bname});
                }
            });
        } else if(!this.state.first_name) {
            this.setState({
                bname: this.state.bname,
                email: this.state.email,
                first_name: values.first_name,
                last_name: values.last_name,
                primary_phone: values.primary_phone,
                address: values.address,
                city: values.city,
                state: values.state,
                zip: values.zip,
                password: values.password,
                password_confirmation: values.password_confirmation
            });
        } else if(!this.state.address) {
            this.setState({
                bname: this.state.bname,
                email: this.state.email,
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                primary_phone: this.state.primary_phone,
                address: values.address,
                city: values.city,
                state: values.state,
                zip: values.zip,
                password: values.password,
                password_confirmation: values.password_confirmation
            });
        } else {
            this.setState({
                bname: this.state.bname,
                email: this.state.email,
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                primary_phone: this.state.primary_phone,
                address: this.state.address,
                city: this.state.city,
                state: this.state.state,
                zip: this.state.zip,
                password: values.password,
                password_confirmation: values.password_confirmation,
                isSubmitting: true
            }, () => {
                this.props.signUp(this.state, this.props.history);
            });
        }
    }

    renderFields() {
        if(!this.state.email) {
            return (
                [
                    <p key='paragraph' className="text-muted">Enter an email to create your account</p>,
                    <div key='div'>
                        <Field
                            name="email"
                            type="email"
                            placeholder="Email"
                            className="form-control"
                            icon="far fa-user"
                            value={this.state.email}
                            component={this.renderField}
                        />
                        <button type="submit" className="btn btn-lg btn-primary full-width">Next</button>
                    </div>
                ]
            )
        } else if(!this.state.first_name) {
            return (
                <div>
                    <Field
                        name="first_name"
                        type="text"
                        placeholder="First name"
                        className="form-control"
                        icon="fa fa-name"
                        value={this.state.first_name}
                        component={this.renderField}
                    />
                    <Field
                        name="last_name"
                        type="text"
                        placeholder="Last name"
                        className="form-control"
                        icon="fa fa-name"
                        value={this.state.last_name}
                        component={this.renderField}
                    />
                    <Field
                        name="primary_phone"
                        type="text"
                        placeholder="Phone"
                        className="form-control"
                        icon="fa fa-phone"
                        value={this.state.primary_phone}
                        component={this.renderField}
                    />
                    <button type="submit" className="btn btn-lg btn-primary full-width">Next</button>
                </div>
            )
        } else if(!this.state.address) {
            return (
                <div>
                    <Field
                        name="address"
                        type="text"
                        placeholder="Address"
                        className="form-control"
                        icon="fa fa-address"
                        value={this.state.address}
                        component={this.renderField}
                    />
                    <Field
                        name="city"
                        type="text"
                        placeholder="City"
                        className="form-control"
                        icon="fa fa-city"
                        value={this.state.city}
                        component={this.renderField}
                    />
                    <Field
                        name="state"
                        type="text"
                        placeholder="State"
                        className="form-control"
                        icon="fa fa-state"
                        value={this.state.state}
                        component={this.renderField}
                    />
                    <Field
                        name="zip"
                        type="text"
                        placeholder="Zip"
                        className="form-control"
                        icon="fa fa-zip"
                        value={this.state.zip}
                        component={this.renderField}
                    />
                    <button type="submit" className="btn btn-lg btn-primary full-width">Next</button>
                </div>
            )

        } else {
            return (
                <div>
                    <Field
                        name="password"
                        type="password"
                        placeholder="Password"
                        className="form-control"
                        icon="fa fa-key"
                        value={this.state.password}
                        component={this.renderField}
                    />

                    <Field
                        name="password_confirmation"
                        type="password"
                        placeholder="Confirm password"
                        className="form-control"
                        icon="fa fa-key"
                        value={this.state.password_confirmation}
                        component={this.renderField}
                    />
                    <button type="submit" className="btn btn-lg btn-primary full-width" disabled={this.state.isSubmitting}>
                        {this.state.isSubmitting ? 'Signing Up...' : 'Sign Up'}
                    </button>
                </div>
            )
        }
    }

    render () {
        const { handleSubmit } = this.props;
        return (
            <div className="flex-center">
                <div className="content-card col-lg-6 col-xs-12">
                    <h1>{CONSTANTS.APP_TITLE}</h1>
                    <form className="members-area-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                        {this.renderFields()}
                    </form>
                    <div className="text-center small mt-10">
                        <span className="text-muted">Already have a login? &nbsp;</span>
                        <Link to={`/${this.state.bname}/login`}>Login here</Link>
                    </div>
                </div>
            </div>
        );
    }
}

function validate(values) {
    let errors = {};
    const fieldValidators = {
        email: (value) => !value && 'Please enter an email',
        first_name: (value) => !value && 'Please enter a first_name',
        last_name: (value) => !value && 'Please enter a last_name',
        primary_phone: (value) => !value && 'Please enter a phone number',
        address: (value) => !value && 'Please enter an address',
        city: (value) => !value && 'Please enter a city',
        state: (value) => !value && 'Please enter a state',
        zip: (value) => !value && 'Please enter a zip code',
        password: (value) => !value && 'Please enter a password',
        password_confirmation: (value) => !value && 'Please confirm your password'
    };

    Object.keys(fieldValidators).forEach((field) => {
        if (Object.prototype.hasOwnProperty.call(values, field)) {
            const error = fieldValidators[field](values[field]);
            if (error) {
                errors[field] = error;
            }
        }
    });

    if (Object.prototype.hasOwnProperty.call(values, 'password') &&
        Object.prototype.hasOwnProperty.call(values, 'password_confirmation') &&
        values.password_confirmation !== values.password) {
        errors.password_confirmation = 'Passwords do not match';
    }

    return errors;
}

export default reduxForm({
    validate: validate,
    form: 'signupForm',
    destroyOnUnmount: false
})(connect(null, { signUp, checkEmail })(SignUp));
